export default __webpack_public_path__ + "static/media/52_BottomLeftSquares_RotateRight.dc67ef6b.mp4";